import {css} from "lit";

export function pxToRem(px: number) {
    const rem = px / 16;
    return css`${rem}rem`;
}